import {
  CLEAR_FLAGS_PARAMETROS_EMBEDDED_BI,
  ERROR_PARAMETROS_EMBEDDED_BI_MSG,
  SET_PARAMETROS_EMBEDDED_BI_INIT,
  SET_PARAMETROS_EMBEDDED_BI_SUCCESS,
  SET_ARQUITETURA_PBI_ATIVA_INIT,
  SET_ARQUITETURA_PBI_ATIVA_SUCCESS,
  ERROR_ARQUITETURA_PBI_ATIVA_MSG,
  CRIAR_WORKSPACE_INIT,
  POWERBI_WORKSPACE_PROGRESS,
  POWERBI_WORKSPACE_SUCCESS,
  POWERBI_WORKSPACE_ERROR,
  ATUALIZAR_WORKSPACE_INIT
} from '../../actionTypes';

const INIT_STATE = {
  isUpdated: false,
  isError: false,
  loading: false,
  msg: '',
  ultimaAbaAtualizada: '',
  isUpdatedArquiteturaAtiva: false,
  isErrorArquiteturaAtiva: false,
  msgArquiteturaAtiva: '',
  // PowerBI Workspace
  powerBiWorkspaceProgress: 0,
  powerBiWorkspaceMessage: '',
  powerBiWorkspaceResult: null,
  powerBiWorkspaceError: null,
  powerBiWorkspaceLoading: false
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case ERROR_PARAMETROS_EMBEDDED_BI_MSG: {
      const { msg } = action.payload;
      return {
        ...state,
        isUpdated: false,
        msg,
        isError: true,
        loading: false
      };
    }
    case SET_PARAMETROS_EMBEDDED_BI_INIT:
      return { ...state, isUpdated: false, loading: true };
    case SET_PARAMETROS_EMBEDDED_BI_SUCCESS: {
      const { msg, chave } = action.payload;
      return { ...state, isUpdated: true, msg, loading: false, ultimaAbaAtualizada: chave || '' };
    }
    case SET_ARQUITETURA_PBI_ATIVA_INIT:
      return {
        ...state,
        isUpdatedArquiteturaAtiva: false,
        isErrorArquiteturaAtiva: false,
        loading: true
      };
    case SET_ARQUITETURA_PBI_ATIVA_SUCCESS: {
      const { msg } = action.payload;
      return {
        ...state,
        isUpdatedArquiteturaAtiva: true,
        msgArquiteturaAtiva: msg,
        loading: false
      };
    }

    case ERROR_ARQUITETURA_PBI_ATIVA_MSG: {
      const { msg } = action.payload;
      return {
        ...state,
        isErrorArquiteturaAtiva: true,
        msgArquiteturaAtiva: msg,
        loading: false
      };
    }
    case CRIAR_WORKSPACE_INIT:
    case ATUALIZAR_WORKSPACE_INIT:
      return { ...state, powerBiWorkspaceLoading: true };

    case POWERBI_WORKSPACE_PROGRESS: {
      return {
        ...state,
        powerBiWorkspaceProgress: action.payload.progress,
        powerBiWorkspaceMessage: action.payload.message,
        powerBiWorkspaceError: null,
        powerBiWorkspaceLoading: true
      };
    }
    case POWERBI_WORKSPACE_SUCCESS: {
      return {
        ...state,
        powerBiWorkspaceResult: action.payload,
        powerBiWorkspaceError: null,
        powerBiWorkspaceProgress: 100,
        powerBiWorkspaceLoading: false
      };
    }
    case POWERBI_WORKSPACE_ERROR: {
      return {
        ...state,
        powerBiWorkspaceError: action.payload,
        powerBiWorkspaceProgress: 0,
        powerBiWorkspaceMessage: action.payload,
        powerBiWorkspaceLoading: false
      };
    }
    case CLEAR_FLAGS_PARAMETROS_EMBEDDED_BI: {
      return {
        ...state,
        isUpdated: false,
        isError: false,
        loading: false,
        msg: '',
        ultimaAbaAtualizada: '',
        isUpdatedArquiteturaAtiva: false,
        isErrorArquiteturaAtiva: false,
        msgArquiteturaAtiva: '',
        powerBiWorkspaceProgress: 0,
        powerBiWorkspaceMessage: '',
        powerBiWorkspaceResult: null,
        powerBiWorkspaceError: null,
        powerBiWorkspaceLoading: false
      };
    }
    default:
      return { ...state };
  }
};
